import { useCallback, useReducer } from "react";
import uuid from "uuid";
import { generateToastTimeout } from "../toast-utils/toast-utils";
/**
 * `useToastProviderState` is a simple state hook that keeps track of the
 * context state for toasts
 */
export const useToastProviderState = ({ toastTimeout, position }) => {
    const [toasts, dispatch] = useReducer((state, { type, id, toast }) => {
        switch (type) {
            case "add":
                return toast && !state.find((n) => n.id === id)
                    ? [
                        ...state,
                        Object.assign({ id, timeout: generateToastTimeout(toast.autoClose, toastTimeout), status: "active", position }, toast),
                    ]
                    : state;
            case "remove":
                return state.map((n) => n.id !== id ? n : Object.assign(Object.assign({}, n), { status: "complete" }));
            case "update":
                return state.map((n) => (n.id === id ? Object.assign(Object.assign({}, n), toast) : n));
            default:
                return state;
        }
    }, []);
    const removeToast = useCallback((id) => {
        dispatch({
            type: "remove",
            id,
        });
    }, []);
    const addToast = useCallback((toast) => {
        var _a;
        dispatch({
            type: "add",
            id: (_a = toast.id) !== null && _a !== void 0 ? _a : uuid.v4(),
            toast,
        });
    }, []);
    const updateToast = useCallback((id, toast) => {
        dispatch({
            type: "update",
            id,
            toast,
        });
    }, []);
    return {
        toasts,
        addToast,
        removeToast,
        updateToast,
    };
};
